module.exports = __webpack_public_path__ + "static/img/teachers.1fdcde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teachers.png
// module id = k/XJ
// module chunks = 20